module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_57-93cbfa2ce6ef45460e9c5538f6ba75b3.png";